import { queryStringToObject } from "./lib/UrlUtils";

export const COUPON_CODE_QS_KEY = "couponCode";

export function getCouponCode(queryString: string): string | null {
  const params = queryStringToObject(queryString);
  return params[COUPON_CODE_QS_KEY] ?? null;
}
